export default "__VITE_ASSET__6e468ff2__"